import { motion } from '@hover/blueprint/foundation';
import { Box, BoxProps, Icon, Divider, Heading } from '@hover/blueprint';
import { iX } from '@hover/icons';
import React, { useState } from 'react';

interface Props extends BoxProps {
  title: string;
  content: string | React.ReactNode;
}

const Accordion: React.FC<Props> = ({ title, content, ...rest }) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const toggleExpand = (): void => {
    setIsExpanded(!isExpanded);
  };

  return (
    <Box
      onClick={toggleExpand}
      w="100%"
      flexDir="column"
      overflow="hidden"
      {...rest}
    >
      <Box
        cursor="pointer"
        w="100%"
        flexDir="row"
        alignItems="center"
        justifyContent="flex-start"
        pt={500}
        pb={400}
      >
        <Icon
          mr={400}
          icon={iX}
          transform={`rotateZ(${isExpanded ? 0 : '45deg'})`}
          transition={`all ${motion.easings[250]}`}
          size="default"
        />
        <Heading
          size={{ base: 200, desktop: 300 }}
          fontWeigth={600}
          style={{ marginBottom: 0, fontWeight: 600 }}
        >
          {title}
        </Heading>
      </Box>
      <Box
        mt={200}
        maxH={isExpanded ? '1000px' : 0}
        transition="all 0.4s ease"
        pl={700}
        overflow="hidden"
      >
        {content}
      </Box>
      <Divider
        borderColor="neutral.500"
        my={0}
        borderWidth="1px"
        borderTopWidth={0}
      />
    </Box>
  );
};

export default Accordion;
